module.exports = __webpack_public_path__ + "img/2.35102446.jpg";